import React from "react";

const SocialButton = () => {
  return (
    <div className="flex flex-col items-center gap-3 ">
      <a
        href="https://t.me/QUYNHNHUCEO88"
        target="_blank"
        className="transition duration-300 ease-in-out transform hover:scale-105"
      >
        <img
          className="cursor-pointer"
          src="/assets/common/telegram.png"
          alt="Telegram"
        />
      </a>
      <a
        href="https://t.me/QUYNHNHUCEO88"
        target="_blank"
        className="transition duration-300 ease-in-out transform hover:scale-105"
      >
        <img
          className="cursor-pointer"
          src="/assets/common/llwin.png"
          alt="LLWIN"
        />
      </a>
    </div>
  );
};

export default SocialButton;
